// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"91":"f13fb74d","181":"0838e69d","847":"dc26ecb5"}[chunkId] + ".chunk.css";
};